import Dropdown from "@stimulus-components/dropdown"

export default class extends Dropdown {
  static targets = ["button", "menu"]

  connect() {
    super.connect()
    this.boundHandleOutsideClick = this.handleOutsideClick.bind(this)
    this.boundHandleEscape = this.handleEscape.bind(this)
    this.close()
  }

  toggle() {
    if (this.menuTarget.classList.contains("hidden")) {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    this.enter()
    this.setExpanded(true)
    document.addEventListener("click", this.boundHandleOutsideClick)
    document.addEventListener("keydown", this.boundHandleEscape)
  }

  close() {
    this.leave()
    this.setExpanded(false)
    document.removeEventListener("click", this.boundHandleOutsideClick)
    document.removeEventListener("keydown", this.boundHandleEscape)
  }

  hide(event) {
    if (event) {
      super.hide(event)
      this.setExpanded(false)
    } else {
      this.close()
    }
  }

  handleOutsideClick(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  handleEscape(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }

  disconnect() {
    document.removeEventListener("click", this.boundHandleOutsideClick)
    document.removeEventListener("keydown", this.boundHandleEscape)
  }

  setExpanded(expanded) {
    if (this.hasButtonTarget) {
      this.buttonTarget.setAttribute("aria-expanded", expanded.toString())
    }
  }
}
